import { isNumber } from '@sonar-software/sonar-ts-lib';
import React from 'react';

export interface VersionNumberProps {
	number?: number;
}

export const VersionNumber: React.FC<VersionNumberProps> = ({ number }) => {
	if (!isNumber(number)) {
		return null;
	}

	const version = `v${number}`;

	return <span className='version'>{ version }</span>;
};
